import PropTypes from 'prop-types';
import {
  Car,
  Droplets,
  Lock,
  Package,
  CupSoda,
  Sun,
  Zap,
  HeartPulse,
  Utensils,
  Wifi,
  HelpCircle,
  Bath,
} from 'lucide-react';
import { Text, Stack } from '@/components/ui/index.js';
import styles from './AmenityGrid.module.css';

/**
 * AmenityGrid - Displays venue amenities in a grid layout
 * Maps amenity names to appropriate icons
 */
export function AmenityGrid({ amenities }) {
  // Map amenity names to icons
  const amenityIcons = {
    parking: Car,
    'water fountain': Droplets,
    showers: Bath,
    lockers: Lock,
    'equipment rental': Package,
    'water station': CupSoda,
    benches: Sun,
    lights: Zap,
    'first aid': HeartPulse,
    concessions: Utensils,
    wifi: Wifi,
    restrooms: Bath,
  };
  const getAmenityIcon = (amenity) => {
    const key = amenity.toLowerCase();
    const Icon = amenityIcons[key] || HelpCircle;
    return Icon;
  };

  if (!amenities || amenities.length === 0) {
    return null;
  }

  return (
    <div className={styles.amenityGrid}>
      <Stack direction="row" gap={2} align="center" className={styles.header}>
        <Zap size={18} className={styles.headerIcon} />
        <Text size="base" weight="semibold" color="primary">
          Amenities
        </Text>
      </Stack>

      <div className={styles.grid}>
        {amenities.map((amenity, index) => {
          const Icon = getAmenityIcon(amenity);
          return (
            <div
              key={index}
              className={styles.amenityItem}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className={styles.iconWrapper}>
                <Icon size={20} className={styles.amenityIcon} />
              </div>
              <Text size="sm" color="secondary" className={styles.amenityLabel}>
                {amenity}
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
}

AmenityGrid.propTypes = {
  amenities: PropTypes.arrayOf(PropTypes.string),
};

export default AmenityGrid;
